/**
 * @generated SignedSource<<3f06ad286b28e1eb53198436ece8fa41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPageHeader_buyer$data = {
  readonly isTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_buyer">;
  readonly " $fragmentType": "CheckoutPageHeader_buyer";
};
export type CheckoutPageHeader_buyer$key = {
  readonly " $data"?: CheckoutPageHeader_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPageHeader_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPageHeader_buyer",
  "selections": [
    {
      "alias": "isTrade",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7f214f31bad746144cb649143140d4d2";

export default node;
